import config from "../config/config";

const getABTest = (page) => {
	let obj = {};
	obj[config.gizmoSetupKey] = page[config.gizmoSetupKey]
		? JSON.parse(JSON.stringify(page[config.gizmoSetupKey]))
		: null; // Get a clone
	obj[config.gizmoPagesKey] = page[config.gizmoPagesKey]
		? JSON.parse(JSON.stringify(page[config.gizmoPagesKey]))
		: null;
	return obj;
};

const switchToTest = (page, testIndex) => {
	try {
		let intTestIndex = parseInt(testIndex);
		let testObj = getABTest(page);
		let currentTestPage = testObj[config.gizmoPagesKey][intTestIndex];
		currentTestPage[config.gizmoSetupKey] = page[config.gizmoSetupKey];
		currentTestPage[config.gizmoPagesKey] = page[config.gizmoPagesKey];
		return currentTestPage;
	} catch (e) {
		console.log("Could not setup AB Test page: ", e.message);
	}
	return page;
};

const abTestPathFound = (testIndex) => {
	if (testIndex && !isNaN(parseInt(testIndex))) return `/${config.gizmoPagesKey}/${testIndex}/`;
	return ``;
};

const onLoad = (callback, delay = 1) => {
	if (document.readyState === "complete") {
		setTimeout(() => callback(), delay);
	} else {
		window.addEventListener("load", function () {
			setTimeout(() => callback(), delay);
		});
	}
};

const allowedToRun = () => {
	const clientString = () => {
		return window.location.host;
	};
	let runningHost = import.meta.client ? clientString() : "";
	let allowedToRun = config.onlyWorksFor.filter((site) => {
		return runningHost && runningHost.indexOf(site) > -1;
	});
	return allowedToRun.length > 0;
};

export default {
	getABTest,
	switchToTest,
	abTestPathFound,
	onLoad,
	allowedToRun,
};
